import { fetchGroupsSuccess, updateUserSuccess, fetchUsersSuccess } from './actions';
import request from 'helpers/superagent';
import config from 'config';
import { eadminQueryAsync } from 'helpers/graphql';

export const fetchGroups = () => {
  const query = `query {
    groups (
      limit: 200
    ) {
      data {
        name
        id
      }
    }
  }
  `
  return eadminQueryAsync(query, {})
    .then((body) => {
      return fetchGroupsSuccess(body.data.groups.data);
    })
};

export const fetchUsers = (data) => {
  const query = `
    query(
      $q: String
      $groupId: String
      $clientId: String
    ) {
      users(
        q: $q
        groupId: $groupId
        limit: 200
        offset: 0
        clientId: $clientId
      ) {
        count
        data {
          id
          username
        }
      }
    }
  `
  return eadminQueryAsync(query, data)
    .then((body) => {
      return fetchUsersSuccess(body.data.users.data);
    })
}

export const updateUser = (data) => {
  const { access_token } = localStorage;
  const { groupId, userId, lang, password, email, username } = data;

  return request.put(`${config.eadmin.baseUrl}/account/groups/${groupId}/users/${userId}`)
    .query({
      access_token,
    })
    .send({
      lang, password, username, email
    })
    .endAsync()
    .get('body')
    .then((me) => {
      return updateUserSuccess(me);
    });
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/eadmin/tasks.js
 **/